import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';

import  { Observable } from 'rxjs/Observable';

import { HttpClient } from './http-client.service';

import { ReportCategory } from '../../entities/report-category';

import { Settings } from '../../settings';

import { DateConverter } from '../../utility/date-converter';

import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';

import { CachedCallService } from './cached-call.service';

@Injectable()
export class ReportCategoryService {
  private readonly headers:Headers = new Headers({ 'Content-Type': 'application/json' });
  private readonly options:RequestOptions = new RequestOptions({ headers: this.headers });

  private static readonly reportCategoryBaseUrl:string = `${Settings.apiUrl}/v1/ReportCategories`;

  protected cachedCallService:CachedCallService = new CachedCallService();

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getReportCategories(): Promise<ReportCategory[]> {
    let reportCategoryUrlCustom: string = `${Settings.apiUrl}/v1/ReportCategories/RCC.GetAllReportCategories()/`;
    let oDataBuilder: ODataBuilder = new ODataBuilder(reportCategoryUrlCustom);

    oDataBuilder
      .orderBy("SortOrder");

    let reportCategoryUrl: string = oDataBuilder.toString();

    return this.http.get(reportCategoryUrl)
      .toPromise()
      .then(response => response.json().value);
  }

  createReportCategory(reportCategory: ReportCategory): Promise<ReportCategory> {
    let reportCategoryUrl: string = `${Settings.apiUrl}/v1/ReportCategories`;
    
    // must remove - breaks deserialization on the server when trying to convert empty string to Guid 
    delete reportCategory.ReportCategoryId;

    return this.http.post(reportCategoryUrl, JSON.stringify(reportCategory), this.options)
      .toPromise()
      .then(response => {
        return response.json();
      });
  }

  patchReportCategory(reportCategory: ReportCategory): Promise<null> {

    let reportCategoryUrl: string = `${Settings.apiUrl}/v1/ReportCategories(${reportCategory.ReportCategoryId})`;

    return this.http.patch(reportCategoryUrl, JSON.stringify(reportCategory), this.options)
      .toPromise()
      .then(response => response);
  }
} 



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/report-category.service.ts